export default function TextInfo({ label, value, classContainer }) {
  return (
    <div className={`flex flex-col ${classContainer} px-2`}>
      <span className="uppercase text-[12px]">{label}</span>
      <strong className="uppercase text-[12px]">{value}</strong>
    </div>
  );
}
